/*! License details at fancyapps.com/license */
var n = function n(_n) {
  return _n && null !== _n && _n instanceof Element && "nodeType" in _n;
};
export { n as isNode };